import tribunalAPI from "api/tribunalAPi";
import { BodyTipoCarpetasPenales } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import moment from "moment";

export type ExpedientesAutorizadosBody = {
  cveMateria: number;
  adolescentes?: "S" | "N";
  cveRegion?: number;
};

export type Expediente = {
  cveJuzgado: string | number;
  cveTipoNumero: string | number;
  idCarpetaJudicial: number;
  numero: number;
  anio: number;
  cveMateria: number;
  adolescentes?: string;
  fechaRadicacion: string;
  tipoCarpeta?: string;
  descCarpetaJudicial?: string;
  archivado?: string;
  concluido?: string;
};

export type JuzgadosExpedientes = {
  cveJuzgado: number;
  descJuzgado: string;
  expedientes: Expediente[];
  CveRegion?: number;
};

export const getExpedientesAutorizados = async (
  body: ExpedientesAutorizadosBody
): Promise<JuzgadosExpedientes[]> => {
  const url = "/expedientes-autorizados";
  const response = (await tribunalAPI.get(url, { params: body })).data.data;
  const res = response.map((data: any) => {
    const expedientesJuzgado = {
      ...data,
      cveJuzgado: Number.parseInt(data.IdJuzgado ?? data.cveJuzgado),
      descJuzgado: data.DesJuz ?? data.desJuzgado,
      expedientes: data.expediente.map((expediente: any) => {
        const data = {
          idCarpetaJudicial: Number.parseInt(expediente.idCarpetaJudicial),
          numero: Number.parseInt(expediente.numero),
          anio: Number.parseInt(expediente.anio),
          fechaRadicacion: moment(expediente.fechaRadicacion).format("L"),
          fechaRegistro: expediente.fechaRegistro,
          cveMateria: body.cveMateria,
          tipoCarpeta: expediente.tbltiposnumero?.descTipoNumero || expediente?.tipoCarpeta,
          cveTipoNumero: expediente.cveTipoNumero,
          descCarpetaJudicial: expediente.descCarpetaJudicial || "",
          cveJuzgado: expediente.cveJuzgado,
          carpetaPadre: expediente?.carpetaPadre ?? null,
          archivado: expediente.archivado,
          concluido: expediente.concluido,
        };

        if (body.cveMateria === 3) {
          // @ts-ignore
          data["adolescentes"] = body.adolescentes;
        }

        if (body.cveMateria === 8) {
          data["descCarpetaJudicial"] = expediente.tipoCarpeta || "";
        }
        return data;
      }),
    };
    // orden en expedientes por fecha de registro
    const expedientesJuzgadoDescending = [
      ...expedientesJuzgado.expedientes,
    ].sort((a, b) => (a.fechaRegistro > b.fechaRegistro ? -1 : 1));
    expedientesJuzgado.expedientes = expedientesJuzgadoDescending;

    return expedientesJuzgado;
  });
  return res;
};

export const getPortadaCarpeta = async (
  idCarpetaJudicial: number
): Promise<any> => {
  const url = "/portadas/obtener-carpetas-judiciales";
  return (await tribunalAPI.get(url, { params: { idCarpetaJudicial } })).data
    .data;
};

export const gerPortadaActuacion = async (
  idActuacion: number,
  cveTipoActuacion: number
): Promise<any> => {
  const url = "/portadas/obtener-actuaciones";
  const params: any = {};

  if (cveTipoActuacion !== 14) {
    params["idActuacion"] = idActuacion;
  } else {
    params["idAudiencia"] = idActuacion;
  }

  return (await tribunalAPI.get(url, { params })).data.data;
};

export const getArbolFromElectronico = async (idExpediente: number) => {
  return (
    await tribunalAPI.get("/expedientes-autorizados/arbol", {
      params: { idCarpetaJudicial: idExpediente },
    })
  ).data.data;
};

export const getArbolPenalLaboral = async (
  idExpediente: number,
  tipo: string
) => {
  const response = await tribunalAPI.get(
    "/expedientes-autorizados/arbol-penal-adolescente-laboral",
    {
      params: {
        idCarpetaJudicial: idExpediente,
        tipo: 2,
        quees: 1,
        tipoSistema: tipo,
      },
    }
  );

  if (response?.data) return response.data?.data;
};

export const obtenerTipoCarpetasPenales = async (
  params: BodyTipoCarpetasPenales
) => {
  let url = "/expedientes-autorizados/tipo-carpetas-penales";
  return await tribunalAPI.get(url, {
    params,
  });
};


export const gerPortadaCarpetaJudicial = async (idCarpetaJudicial: number) => {
  let url = "/portadas/obtener-carpetas-judiciales";

  return await tribunalAPI.get(url, {
    params: {
      idCarpetaJudicial: idCarpetaJudicial
    }
  });
};

export const getIsArchivado = async (
  idCarpetaJudicial: number,
  cveSistema: number,
) => {
  let url = "/archivados";
  return await tribunalAPI.get(url, { params: { idCarpetaJudicial, cveSistema } });
};

export const postIsArchivado = async (
  idCarpetaJudicial: number,
  cveSistema: number,
  archivar: string
) => {
  let url = "/archivados";
  return await tribunalAPI.post(url, { idCarpetaJudicial, cveSistema, archivar });
};

